<template>
  <a
    v-if="currentPagePDF.url"
    class="ml-1 underline text-xs mb-3 text-xs"
    :href="currentPagePDF.url"
    :title="`Generated ${timeSinceGeneration}`"
    alt="download-page-pdf"
  >
    <button class="rounded-md font-medium border py-2 px-4"><BaseIcon icon="file-download" /><span class="ml-2">Download as PDF</span></button>
  </a>
</template>

<script>
import { formatRelative } from 'date-fns'

export default {
  props: {
    pageId: {
      type: String,
      default: '',
    },
  },
  data() {
    return { currentPagePDF: {} }
  },
  computed: {
    timeSinceGeneration() {
      return formatRelative(
        new Date((this.currentPagePDF || {}).generatedAt),
        new Date()
      )
    },
  },
  async mounted() {
    try {
      this.currentPagePDF = await this.fetchData()
    } catch (err) {
      if (
        // Backend returns "Catalog page report not found" error if catalog pdf has been never generated for catalog page.
        err.response.status !== 418 ||
        err.response.data.error !== 'Catalog page report not found'
      ) {
        this.$bugsnag.notify(err)
        throw err
      }
    }
  },
  methods: {
    fetchData() {
      return this.$axios.$get(
        `${this.$store.state.settings.school}/pdf-reports/catalogs/${
          this.$store.state.settings.activeCatalog
        }/pages/${this.pageId}`
      )
    },
  },
}
</script>
